<template>
	<div class="payment">
		<dialog-or-inline
			:embedded="embedded"
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('payment.edit')"
			:visible.sync="dialogPayment"
			width="850px"
			top="6vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')" :class="{ 'pay-embed': embedded }">
				<el-form
					:label-position="labelPosition"
					ref="payment"
					:label-width="embedded ? 'auto' : '80px'"
					:model="payment.payConfig">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('payment.coin')" prop="isCoin">
								<el-select
									:disabled="$tools.IsGrayModule('usermahcine:gray:iscoin')"
									v-model="payment.payConfig.isCoin"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="payment.payConfig.isCoin == 1" :span="12">
							<el-form-item :label="$t('payment.coinAcceptor')" prop="coinType">
								<el-select
									v-model="payment.payConfig.coinType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in coinAcceptorItem"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('payment.banknote')" prop="isBill">
								<el-select
									:disabled="$tools.IsGrayModule('usermahcine:gray:isbill')"
									v-model="payment.payConfig.isBill"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="payment.payConfig.isBill == 1" :span="12">
							<el-form-item :label="$t('payment.billType')" prop="billType">
								<el-select
									v-model="payment.payConfig.billType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in billAcceptorItem"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('payment.creditCard')" prop="isCard">
								<el-select
									v-model="payment.payConfig.isCard"
									:disabled="$tools.IsGrayModule('usermahcine:gray:iscard')"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="payment.payConfig.isCard == 1" :span="12">
							<el-form-item :label="$t('payment.cardReader')" prop="cardType">
								<el-select
									v-model="payment.payConfig.cardType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in shuaKaQi"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item :label="$t('payment.isPaypal')" prop="isPaypal">
								<el-select
									:disabled="$tools.IsGrayModule('usermahcine:gray:ispaypal')"
									v-model="payment.payConfig.isPaypal"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item
								:label="$t('payment.isCoinReturn')"
								prop="isCoinRefund">
								<el-select
									:disabled="
										$tools.IsGrayModule('usermahcine:gray:iscoinrefund')
									"
									v-model="payment.payConfig.isCoinRefund"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<!-- <el-col :span="8">
							<el-form-item :label="$t('payment.Redemption')" prop="isFree">
								<el-select
									:disabled="$tools.IsGrayModule('usermahcine:gray:isfree')"
									v-model="payment.payConfig.isFree"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer pay-footer">
				<span v-if="embedded && dirty" class="pay-dirty"><i class="el-icon-warning-outline"></i> {{ $t("machinesHub.configDirty") }}</span>
				<el-button v-if="!embedded" @click="cancel('')" size="small">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('payment')"
					size="small"
					>{{ embedded ? $t("machinesHub.savePayment") : $t("common.definite") }}</el-button
				>
			</div>
		</dialog-or-inline>
	</div>
</template>

<script>
import DialogOrInline from "./DialogOrInline";
export default {
	name: "Payment",
	components: { DialogOrInline },
	props: {
		dialogPayment: Boolean,
		payment: Object,
		yesNo: Array,
		shuaKaQi: Array,
		coinAcceptorItem: Array,
		billAcceptorItem: Array,
		embedded: { type: Boolean, default: false }
	},
	mounted() {
		if (this.embedded) this.openDialog();
	},
	data() {
		return {
			labelPosition: "top",
			loadingForm: false,
			dirty: false,
			ready: false,
		};
	},
	watch: {
		"payment.payConfig": {
			deep: true,
			handler() {
				if (this.ready) this.dirty = true;
			},
		},
	},
	methods: {
		closeDialog() {
			this.cancel("");
		},

		openDialog() {
			this.dirty = false;
			this.ready = false;
			this.$nextTick(() => {
				this.ready = true;
			});
		},

		cancel(state) {
			this.$emit("cancelPayment", false, state);
		},

		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					this.$api
						.request(
							this.$url.UserMachine.payment,
							this.$method.put,
							this.payment
						)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.dirty = false;
								this.cancel(this.payment.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
	border-radius: 6px;
	font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
		"Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	.el-dialog__header {
		padding: 15px 15px 15px 20px;
		background-color: var(--vtm-mint);
		border-radius: 5px 5px 0 0;
	}
	.el-dialog__headerbtn .el-dialog__close {
		color: var(--vtm-surface);
	}
	.el-dialog__title {
		color: var(--vtm-surface);
	}
	.el-dialog__body {
		padding: 20px 20px 0 20px;
	}
	.el-dialog__footer {
		padding: 20px;
	}
	.el-form--label-top .el-form-item__label {
		padding: 0;
	}
	.el-form-item {
		margin: 0;
	}
	.el-dialog__headerbtn {
		top: 20px;
		right: 15px;
	}
}

/* 内嵌（飞出页签）模式：单列、对齐、不溢出 */
.pay-embed ::v-deep {
	.el-row {
		margin: 0 !important;
	}
	.el-col {
		width: 100% !important;
		max-width: 100% !important;
		flex: 0 0 100% !important;
		padding: 0 !important;
	}
	.el-form-item {
		margin-bottom: 16px !important;
	}
	.el-form-item__label {
		white-space: normal;
		line-height: 1.4;
		color: var(--vtm-ink-2);
		font-weight: 600;
	}
	.el-select,
	.el-input {
		width: 100%;
	}
}
.pay-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
}
.pay-dirty {
	margin-right: auto;
	font-size: 12px;
	color: var(--vtm-warn);
}
</style>
